export default "__VITE_ASSET__BCSUJOG$__"